import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { switchMap, first, catchError } from "rxjs/operators";
import { EMPTY, zip } from "rxjs";

import { AuthService, AppFacade, UserFacade } from "@app/core/app-services";
import { PropertiesService } from "@app/core/services";

@Component({
  selector: "ingo-auth-callback",
  template: `
    <div class="auth-callback-container">
      <ingo-loader></ingo-loader>
    </div>
  `,
  styles: [
    `
      .auth-callback-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100vh;
        padding: 20px;
        text-align: center;
      }
    `,
  ],
})
export class AuthCallbackComponent implements OnInit {
  private authorizationCode: string | null = null;

  constructor(
    private router: Router,
    private authService: AuthService,
    private appFacade: AppFacade,
    private userFacade: UserFacade,
    private properties: PropertiesService
  ) {
    if (!this.authorizationCode) {
      this.authorizationCode = sessionStorage.getItem("WAS_AUTH_CODE");

      sessionStorage.removeItem("WAS_AUTH_CODE");
    }
  }

  ngOnInit(): void {
    if (!this.authorizationCode) {
      this.router.navigate(["/dashboard"]);
      return;
    }

    this.properties
      .fetch()
      .pipe(
        first(),
        switchMap(() => {
          return this.authService.exchangeAuthorizationCode(
            this.authorizationCode
          );
        }),
        switchMap(() => {
          this.appFacade.setAuthenticated(true);

          const cleanHash = window.location.hash.split("?")[0] || "#/";
          const cleanUrl =
            window.location.origin + window.location.pathname + cleanHash;
          window.history.replaceState({}, "", cleanUrl);

          return this.userFacade.fetchCurrentUser();
        }),
        switchMap((user) => {
          if (!user) {
            return EMPTY;
          }
          return zip(
            this.userFacade.hasDateOfBirth(),
            this.userFacade.ageVerifiedNegative(),
            this.userFacade.hasMarkedMarketingConsent()
          ).pipe(first());
        }),
        catchError(() => {
          this.appFacade.setAuthenticated(false);
          this.authService.handleAuthentication();
          return EMPTY;
        })
      )
      .subscribe((result) => {
        if (result === null) {
          return;
        }

        const [hasDOB, verifiedNegative, consentMarked] = result;

        if (
          this.appFacade.shouldRedirectUser(
            hasDOB,
            verifiedNegative,
            consentMarked
          )
        ) {
          return;
        }

        const navigated = this.authService.goToOriginalRouteIfExists();

        if (!navigated) {
          this.router.navigate(["/dashboard"]);
        }
      });
  }
}
